// Fax failure warning (5.12.0). Polls Telecom's GET /telecom/api/fax_alerts every
// 30 s with the InsureDocs token — the same plain fetch + Bearer header as the
// Telecom unread badge in Main.js. Telecom decides who sees which alerts (the
// sender, managers and admins); nothing here checks roles. Errors and 401 are
// silent and keep the last known state (plain fetch never reaches authSession's
// relogin flow). Renders nothing while there are no alerts, so the page layout
// is unchanged then. Mark handled / Resend live in Telecom only.
//
// Rendered as the LAST child of the TOPBAR's wrapping flex row: a 100%-basis item
// always wraps onto its own line, and the negative margins cancel the TOPBAR's
// padding so the strip runs edge to edge along its bottom. Fixed colours (not the
// theme vars), so it reads the same in light and dark mode.
import React, { useEffect, useState } from 'react';

const POLL_MS = 30000;
const KIND_LABEL = { failed: 'Failed', stuck: 'No result after 30 min' };
const RED = '#dc2626';
const WHITE = '#fff';

export default function FaxAlertStrip() {
  const [alerts, setAlerts] = useState({ count: 0, items: [] });

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const res = await fetch('/telecom/api/fax_alerts', {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        if (!res.ok || cancelled) return;
        const data = await res.json();
        if (cancelled || !data || typeof data.count !== 'number') return;
        setAlerts({ count: data.count, items: Array.isArray(data.items) ? data.items : [] });
      } catch { /* ignore transient */ }
    };
    load();
    const id = setInterval(load, POLL_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!alerts.count) return null;
  const newest = alerts.items[0];
  const more = alerts.count - 1;

  return (
    <div role="alert" style={{ flex: '0 0 calc(100% + 32px)', margin: '0 -16px -6px', boxSizing: 'border-box', padding: '6px 16px', background: RED, color: WHITE, display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: 12, rowGap: 6, fontSize: 13 }}>
      <span style={{ color: WHITE, fontWeight: 700, whiteSpace: 'nowrap' }}>
        ⚠ {alerts.count} fax{alerts.count === 1 ? '' : 'es'} need{alerts.count === 1 ? 's' : ''} attention
      </span>
      {newest && (
        <span style={{ color: WHITE, minWidth: 0 }}>
          <span style={{ color: WHITE, fontWeight: 600 }}>{newest.display_name || 'Unknown recipient'}</span>
          <span style={{ color: WHITE }}> · {KIND_LABEL[newest.kind] || newest.kind}</span>
          <span style={{ color: WHITE }}> · sent by {newest.sender_label}</span>
        </span>
      )}
      {newest && (
        <button onClick={() => window.open(`/telecom/faxes?thread=${encodeURIComponent(newest.thread_id)}`, '_blank')}
          title="Open this conversation in Telecom"
          style={{ padding: '4px 12px', background: WHITE, color: RED, border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
          Open in Telecom
        </button>
      )}
      {more > 0 && (
        <button onClick={() => window.open('/telecom/inbox', '_blank')}
          title="Telecom's red bar lists them all"
          style={{ padding: 0, background: 'transparent', color: WHITE, border: 'none', fontSize: 12, fontWeight: 600, textDecoration: 'underline', cursor: 'pointer', whiteSpace: 'nowrap' }}>
          +{more} more
        </button>
      )}
    </div>
  );
}
